import { IUnit } from '@shared/models/unit';

export function sortUnitsByName(units: IUnit[]): IUnit[] {
    if (!units) {
        return [];
    }
    return [...units].sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
}
